/** Shared screen identifiers. Values match existing telemetry and workbook data. */
export enum PortalTelemetryScreen {
    AbsenceFromPracticePcs = 'AbsenceFromPracticePcs',
    AccessCardAlumni = 'AccessCardAlumni',
    AccessCardFellowAndMember = 'AccessCardFellowAndMember',
    ActivityDetails = 'ActivityDetails',
    AddCpdForm = 'AddCpdForm',
    AddSupportingDocument = 'AddSupportingDocument',
    AddWorkDetails = 'AddWorkDetails',
    AffiliateMembershipForm = 'AffiliateMembershipForm',
    AffiliateMembershipRenewForm = 'AffiliateMembershipRenewForm',
    AlumniVolunteeringForm = 'AlumniVolunteeringForm',
    AppPcsEventSwitchField = 'AppPcsEventSwitchField',
    ApplicantDetails = 'ApplicantDetails',
    BackToRequests = 'BackToRequests',
    CalendarEventDetailsPage = 'CalendarEventDetailsPage',
    CalendarOfActivities = 'CalendarOfActivities',
    CalendarOfActivitiesForm = 'CalendarOfActivitiesForm',
    ChangeOfName = 'ChangeOfName',
    ClassNotes = 'ClassNotes',
    CloneCpdForm = 'CloneCpdForm',
    ConfirmReviewerDetails = 'ConfirmReviewerDetails',
    ContactClassmates = 'ContactClassmates',
    CpdDataList = 'CpdDataList',
    Declaration = 'Declaration',
    DonationDashboard = 'DonationDashboard',
    DonationPaymentSuccessful = 'DonationPaymentSuccessful',
    DonationsDirectDebit = 'DonationsDirectDebit',
    DonationsForm = 'DonationsForm',
    Enrolment = 'Enrolment',
    EventApprovalForm = 'EventApprovalForm',
    EventApprovalSteps = 'EventApprovalSteps',
    EventCard = 'EventCard',
    EventDetails = 'EventDetails',
    EventDocumentsMediaCard = 'EventDocumentsMediaCard',
    EventSubmission = 'EventSubmission',
    EventsHeader = 'EventsHeader',
    EventsInstanceCredits = 'EventsInstanceCredits',
    EventsStepsHeader = 'EventsStepsHeader',
    Feedback = 'Feedback',
    FileDocument = 'FileDocument',
    Header = 'Header',
    InGoodStanding = 'InGoodStanding',
    Linkedin = 'Linkedin',
    ManageDirectDebit = 'ManageDirectDebit',
    MediaCard = 'MediaCard',
    MemberInGoodStanding = 'MemberInGoodStanding',
    Membership = 'Membership',
    MembershipDirectDebit = 'MembershipDirectDebit',
    MembershipOnboardingForm = 'MembershipOnboardingForm',
    MembershipOnboardingHeader = 'MembershipOnboardingHeader',
    MembershipPaymentSummary = 'MembershipPaymentSummary',
    MembershipRenewForm = 'MembershipRenewForm',
    MembershipRenewSubscriptionFeesDue = 'MembershipRenewSubscriptionFeesDue',
    MembershipRenewalPaymentSummary = 'MembershipRenewalPaymentSummary',
    MembershipTransferForm = 'MembershipTransferForm',
    MembershipTransferHeader = 'MembershipTransferHeader',
    MembershipVolunteeringForm = 'MembershipVolunteeringForm',
    Merchandise = 'Merchandise',
    MyDirectDebits = 'MyDirectDebits',
    MyDocumentsForm = 'MyDocumentsForm',
    MyReceipts = 'MyReceipts',
    MyReceiptsForm = 'MyReceiptsForm',
    MyRecurringPayments = 'MyRecurringPayments',
    NonAffiliateMembershipRenewalForm = 'NonAffiliateMembershipRenewalForm',
    NotInGoodStanding = 'NotInGoodStanding',
    OrganiserDetails = 'OrganiserDetails',
    OrganiserDetailsHeader = 'OrganiserDetailsHeader',
    PCSDetails = 'PCSDetails',
    PasTest = 'PasTest',
    PayInAdvance = 'PayInAdvance',
    PaymentUnsuccessful = 'PaymentUnsuccessful',
    PcsEventDialog = 'PcsEventDialog',
    PcsEventEducationalDetails = 'PcsEventEducationalDetails',
    PcsPlanDashboard = 'PcsPlanDashboard',
    PcsPlanStatus = 'PcsPlanStatus',
    PdpReviewerForm = 'PdpReviewerForm',
    PlanDetails = 'PlanDetails',
    PlanReviewerDetails = 'PlanReviewerDetails',
    ReductionsAndExemptions = 'ReductionsAndExemptions',
    RequestForm = 'RequestForm',
    RequestPortalAccess = 'RequestPortalAccess',
    RequestToWithdrawPcs = 'RequestToWithdrawPcs',
    RestrictCpdUpdateDialog = 'RestrictCpdUpdateDialog',
    ReviewerComments = 'ReviewerComments',
    Sponsorship = 'Sponsorship',
    SuccessResponse = 'SuccessResponse',
    SummaryForm = 'SummaryForm',
    SupportingDocuments = 'SupportingDocuments',
    SupportingDocumentsHeader = 'SupportingDocumentsHeader',
    Tours = 'Tours',
    Unauthorized = 'Unauthorized',
    UpcomingEventsPage = 'UpcomingEventsPage',
    UpdateCpdForm = 'UpdateCpdForm',
    UpdatePlannedActivities = 'UpdatePlannedActivities',
    UpdateProfile = 'UpdateProfile',
    ViewCpdDetails = 'ViewCpdDetails',
    ViewCpdForm = 'ViewCpdForm',
    ViewCpdRecord = 'ViewCpdRecord',
    ViewFeedback = 'ViewFeedback',
    ViewPlannedActivities = 'ViewPlannedActivities',
    ViewReviewer = 'ViewReviewer',
    ViewReviewerDetails = 'ViewReviewerDetails',
    VolunteerRequest = 'VolunteerRequest',
    VolunteeringForm = 'VolunteeringForm',
    WorkDetails = 'WorkDetails',
    Yearbook = 'Yearbook'
}
